'use strict';

import {SectionCtrl} from "../esfasi/sectionctrl";

export class Projectreportsdeclarationsctrl extends SectionCtrl {
	constructor($scope, $filter, jsDataService) {
		super($scope, $filter, jsDataService);

		const benefitionVal = parseInt(this.jsDataService.data.reporting.declare_benefition_on, 10);
		const submittionVal = parseInt(this.jsDataService.data.reporting.declare_submittion_on, 10);

		this.declareBenefitionOn = (benefitionVal === 1);
		this.declareBenefitionComment = this.declareBenefitionOn ? '' : (this.jsDataService.data.reporting.declare_benefition_comment ?? '');
		this.declareSubmittionOn = (submittionVal === 1);
		this.declareSubmittionComment = this.declareSubmittionOn ? '' : (this.jsDataService.data.reporting.declare_submittion_comment ?? '');
	}

	go2Url(urlString) {
		this.$scope.goUrl(urlString);
	}

	autosavePostFields() {
		return {
			declare_benefition_on: this.declareBenefitionOn ? 1 : 0,
			declare_benefition_comment: this.declareBenefitionComment,
			declare_submittion_on: this.declareSubmittionOn ? 1 : 0,
			declare_submittion_comment: this.declareSubmittionComment,
			report_id: this.jsDataService.data.reporting.id
		};
	}

	onBenefitionChange() {
		if (this.declareBenefitionOn) {
			this.declareBenefitionComment = '';
		}
	}

	onSubmittionChange() {
		if (this.declareSubmittionOn) {
			this.declareSubmittionComment = '';
		}
	}
}
